<style scoped>

</style>
<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :min-width="180"
    top
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :label="field.label"
        :placeholder="field.placeholder"
        v-bind="attrs"
        :value="invoice_info"
        readonly
        :rules="field.rules"
        :required="field.required"
        v-on="on"
      >
        <template v-slot:label> 
          <span><span
            v-show="field.required"
            style="color:red"
          >*</span>{{ field.label }}</span>
        </template>
      </v-text-field>
    </template>

    <v-card>
      <v-list>
        <v-list-item>
          <v-select
            v-model="my_value[field.key]"
            :items="invoice_types"
            item-text="name"
            label="发票类型"
            hide-details
            @change="taxDataChange(my_value)"
          />
        </v-list-item>
        <v-list-item v-if="is_special_invoice">
          <v-select
            v-model="my_value[tax_rate_key]"
            :items="tax_items"
            label="税率"
            hide-details
            @change="taxDataChange(my_value)"
          />
        </v-list-item>
        <v-list-item v-if="is_special_invoice">
          <v-text-field
            v-model="my_value[tax_key]"
            label="税额"
            hide-details
          />
        </v-list-item>
      </v-list>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="menu = false"
        >
          确定
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
  import InvoiceUtil from '@/views/invoice/libs/util';
  import commonMixins from '../components/commonMixins'
  export default {
    mixins: [ commonMixins ],
    props: {
      value: {
        type: Object,
      },
      field: {
        // price_key
        // tax_rate_key
        // tax_key
        type: Object,
      },
    },
    data() {
      return {
        menu: false,
        invoice_types: InvoiceUtil.invoice_types,
        tax_items: [
          {value: '0.0', text: '0%'},
          {value: '0.01', text: '1%'},
          {value: '0.02', text: '2%'},
          {value: '0.03', text: '3%'},
          {value: '0.04', text: '4%'},
          {value: '0.05', text: '5%'},
          {value: '0.06', text: '6%'},
          {value: '0.07', text: '7%'},
          {value: '0.08', text: '8%'},
          {value: '0.09', text: '9%'},
          {value: '0.1', text: '10%'},
          {value: '0.13', text: '13%'},
          {value: '0.16', text: '16%'},
        ]
      }
    },
    computed: {
      // 是否为专票
      is_special_invoice() {
        return this.my_value[this.field.key] === 1;
      },
      invoice_info() {
        const e = this.my_value;
        // 未选择
        if ([null, '', undefined, -1].includes(e[this.field.key])) {
          return '';
        }
        let info = `类型: ${InvoiceUtil.getInvoiceType(e[this.field.key])}`;
        // 专票显示其他信息
        if (this.is_special_invoice) {
          info += ` - 税率: ${InvoiceUtil.getTaxRate(e.tax_rate)}`;
          info += ` - 税额: ${this.$util.formatPrice(e.tax)}`;
        }
        return info;
      },
      price_key() {
        return this.field.price_key || 'price'
      },
      tax_rate_key() {
        return this.field.tax_rate_key || 'tax_rate'
      },
      tax_key() {
        return this.field.tax_key || 'tax'
      }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      taxDataChange(expense = this.my_value) {
        [ this.price_key, this.tax_rate_key, this.tax_key ].forEach(key => {
          if (!expense[key]) {
            this.$set(expense, key, 0)
          }
        })
        if (this.is_special_invoice) {
          const price = expense[this.price_key];
          const tax_rate = expense[this.tax_rate_key];
          expense[this.tax_key] = math.eval(`${price} * ${tax_rate} / (1 + ${tax_rate})`).toFixed(2);
        } else {
          expense[this.tax_rate_key] = '0.0';
          expense[this.tax_key] = 0;
        }
      },
    }
  }
</script>
